export const NICE_JOB_CONFIGS = {
	clientId: 'nice-jobs-protected.client-id',
	clientSecret: 'nice-jobs-private.client-secret',
	refreshToken: 'nice-jobs-protected.refresh-token',
	accessToken: 'nice-jobs-protected.access-token',
	tokenValidUntil: 'nice-jobs-protected.token-valid-until'
};
